import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import * as api from "../lib/api.js";
import { ApiError } from "../lib/api.js";
import * as s from "../styles.js";

export function ResetPasswordPage(): JSX.Element {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState(searchParams.get("token") ?? "");
  const [newPassword, setNewPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  async function handleSubmit(e: React.FormEvent): Promise<void> {
    e.preventDefault();
    setError(null);
    try {
      await api.resetPassword(token, newPassword);
      setDone(true);
      setTimeout(() => navigate("/login", { replace: true }), 1500);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Could not reset your password.");
    }
  }

  if (done) {
    return (
      <div style={s.container}>
        <h1 style={s.heading1}>Password updated</h1>
        <p style={s.mutedText}>Taking you to sign in…</p>
      </div>
    );
  }

  return (
    <div style={s.container}>
      <h1 style={s.heading1}>Reset your password</h1>
      <form onSubmit={(e) => void handleSubmit(e)} style={{ maxWidth: 360 }}>
        <label style={s.label}>
          Reset token
          <input style={s.input} required value={token} onChange={(e) => setToken(e.target.value)} />
        </label>
        <label style={s.label}>
          New password (at least 10 characters)
          <input
            style={s.input}
            type="password"
            required
            minLength={10}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
        </label>
        {error && <p style={s.errorText}>{error}</p>}
        <button type="submit" style={s.buttonPrimary}>
          Reset password
        </button>
      </form>
    </div>
  );
}
